<script setup lang="ts">
import type { InfoLevel } from "@/model/baseTypes";
import { linkColors } from "@/model/colors";

import SvgIcon from "./SvgIcon/SvgIcon.vue";

defineProps<{ linkState: InfoLevel }>();
</script>

<template>
  <SvgIcon
    name="filled/flash"
    class="flash-icon"
    width="20"
    height="20"
    :style="{ color: linkColors[linkState] }"
  />
</template>
